import axios from '@utils/axios';

const editProductVoucher = {
  state: {
    productVoucherId: 0,
    voucherType: 1,
    fromWho: '',
    forWho: '',
    validTo: ''
  },
  mutations: {
    setProductVoucherId(state, val) {
      state.moneyVoucherId = val;
    },
    setVoucherType(state, val) {
      state.voucherType = val;
    },
    setFromWho(state, val) {
      state.fromWho = val;
    },
    setForWho(state, val) {
      state.forWho = val;
    },
    setValidTo(state, val) {
      state.validTo = val;
    }
  },
  actions: {
    fetchProductVoucher(context) {
      return axios.get('admin/vouchers/getproductvoucher', {
        params: {
          Id: context.state.moneyVoucherId
        }
      }).then((res) => {
        context.commit('setVoucherType', res.data.result.voucherType);
        context.commit('setFromWho', res.data.result.fromWho);
        context.commit('setForWho', res.data.result.forWho);
        context.commit('setValidTo', res.data.result.validTo);
      });
    },
    editVoucher(context) {
      return axios.post('admin/vouchers/editproductvoucher', {
        VoucherId: Number(context.state.moneyVoucherId),
        ForWho: context.state.voucherType === 2 ? context.state.forWho : '',
        FromWho: context.state.voucherType === 2 ? context.state.fromWho : '',
        ValidTo: context.state.validTo
      });
    },
    resetContext(context) {
      context.commit('setVoucherType', 1);
      context.commit('setFromWho', '');
      context.commit('setForWho', '');
      context.commit('setValidTo', '');
    },
  },
  namespaced: true
};

export default editProductVoucher;
